import { useContext } from "react";
import { Alert } from "@mui/material";
import { AppContext } from "../../../../../common/contexts/app_context/app_context";
import { useConfigureLoginViewModel } from "../../viewModels/configure_login_view_model";
import { ConfigureLoginStepOne } from "./components/step_one";
import { ConfigureLoginStepTwo } from "./components/step_two";
import { ConfigureLoginStepThree } from "./components/step_three";
import { ConfigureLoginStepFour } from "./components/step_four";

import ThemeSwitch from "../../../../../common/components/theme_switch";
import ProgressBar from "../../../../../common/components/progress_bar";
import ButtonBack from "../../../../../common/components/button_back";
import CircularLoading from "../../../../../common/components/circular_loading";

/**
 * ConfigureLogin
 */

export const ConfigureLogin = () => {
  const { theme, toggleTheme } = useContext(AppContext);
  const viewModel = useConfigureLoginViewModel();

  return (
    <>
      <div className="top-0 fixed w-full h-16 border-b-[1px] border-b-border-light-gray dark:border-b-border-dark-gray bg-light-gray dark:bg-background-dark flex flex-row items-center justify-between px-4 z-50">
        <div></div>
        <ThemeSwitch label={false} theme={theme} toggleTheme={toggleTheme} />
      </div>

      <div className="w-screen min-h-screen bg-white dark:bg-background-dark flex flex-col items-center justify-between overflow-y-scroll overflow-x-hidden">
        <div>
          <div className="w-screen h-full p-6 mt-16 max-w-[550px] lg:w-[550px]">
            <ProgressBar
              variant="determinate"
              value={viewModel.step * 25} />

            <div className="w-full mt-8">
              {
                viewModel.step !== 4 &&
                <ButtonBack onClick={viewModel.handleBackClick} />
              }
            </div>
            {
              viewModel.loading === true &&
              <div className="w-full h-72 flex justify-center items-center">
                <CircularLoading size={35} />
              </div>
            }
            {
              (viewModel.step === 1 && viewModel.loading === false) &&
              <ConfigureLoginStepOne
                search={viewModel.search}
                filteredEnterprise={viewModel.filteredEnterprises}
                onSearchChange={(search) => viewModel.setSearch(search)}
                onClick={viewModel.handleSelectedEnterprise} />
            }
            {
              (viewModel.step === 2 && viewModel.loading === false) &&
              <ConfigureLoginStepTwo
                hookForm={viewModel.hookForm}
                onSubmit={viewModel.handleSubmit} />
            }
            {
              (viewModel.step === 3 && viewModel.loading === false) &&
              <ConfigureLoginStepThree
                value={viewModel.newLogin}
                error={viewModel.newLoginError}
                errorMessage={viewModel.newLoginErrorMessage}
                newLoginAccepted={viewModel.newLoginAccepted}
                onChangeValue={(v) => viewModel.setNewLogin(v)}
                onAvailableLogin={viewModel.handleNewLogin}
                onClick={viewModel.handleSubmit} />
            }
            {
              (viewModel.step === 4 && viewModel.loading === false) &&
              <ConfigureLoginStepFour
                userExisting={viewModel.userExisting}
                onClick={viewModel.handleFinish} />
            }
            {
              viewModel.hookForm.formState.errors.root !== undefined &&
              <Alert severity="error">{viewModel.hookForm.formState.errors.root.message ?? ""}</Alert>
            }
          </div>
        </div>
      </div>
    </>
  );
};